import result from 'lodash/result'
import RA from 'ra-config'
import { coreSiteUrl } from 'lib/config/url'

/**
 * Generates a Learn More hyperlink for a strategy. While all strategies have a region-specific value
 * to display on the site, there are some for which there will be a region-agnostic description/methodology
 * blurb to link to externally. The anchor tag is derived from category, strategy name,
 * and region (only if region-specific in external doc)
 *
 * @export
 * @param {String} name
 * @param {String} category
 * @param {String} region
 * @returns {String}
 */
export function forStrategy(name, category, region) {
  const singleLearnMoreLink = result(
    RA.content.strategies.descriptions,
    [name, 'singleLearnMoreLink'],
    true
  )
  const categoryItem = RA.app.strategies.categoryList.find(
    item => item.name === category
  )
  const strategyItem = RA.app.strategies.strategyList.find(
    item => item.name === name
  )

  let anchor = ''
  if (categoryItem && strategyItem) {
    anchor +=
      categoryItem.shortName.toLowerCase() +
      '-' +
      strategyItem.shortName.toLowerCase()
    if (!singleLearnMoreLink) {
      anchor += '-' + region.toLowerCase()
    }
  }

  anchor = anchor.replace(/&/, '')

  return learnMoreLink(anchor)
}

/**
 * Generates a Learn More hyperlink for a factor. All factors
 * point to the same location in the external doc.
 *
 * @export
 * @returns {String}
 */
export function forFactor() {
  return learnMoreLink('factors')
}

/**
 * Generates a Learn More url from configuration.
 * Optionally appends the anchor provided.
 *
 * @export
 * @param {String} anchor
 * @returns {String}
 */
export function learnMoreUrl(anchor) {
  let learnMorePath = result(RA.content, 'learnMorePath', '')
  learnMorePath = coreSiteUrl(learnMorePath)
  if (anchor) learnMorePath += '#' + anchor

  return learnMorePath
}

/**
 * Generates a Learn More hyperlink. Optionally appends the anchor provided.
 * If text is provided it will override hyperlink text defined in configuration.
 *
 * @export
 * @param {String} anchor
 * @param {String} text
 * @returns {String}
 */
export function learnMoreLink(anchor, text) {
  let learnMoreText = text
    ? '<a href="{learnMoreUrl}" target="_blank">' + text + '</a>'
    : result(RA.content, 'learnMoreText', '')
  learnMoreText = learnMoreText.replace(
    /\{learnMoreUrl\}/,
    learnMoreUrl(anchor)
  )

  return learnMoreText
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/config/learn-more.js